export { getMonthlyCalendarGrid as getDays } from '@/components/base-components/components/calendar/utils/ranges.js';

export function getMonths(date) {
    return Array.from({ length: 12 }, (_, index) => {
        const item = new Date(date);

        item.setMonth(index);

        return item;
    });
}

export function getYearsRange(date, count = 12) {
    const year = date.getFullYear();

    const groupIndex = Math.floor(year / count);

    const start = groupIndex * count;
    const end = start + count - 1;

    return { start, end };
}

export function getYears(date, count = 12) {
    const { start, end } = getYearsRange(date, count);

    const result = [];

    for (let year = start; year <= end; year++) {
        const item = new Date(date);
        item.setFullYear(year);

        result.push(item);
    }

    return result;
}
